/**
 * Example GraphQL Mutations
 * 
 * This file demonstrates how to structure your mutations.
 * You can create separate files for different domains (e.g., user.mutations.ts, product.mutations.ts)
 * and export them from the index.ts file.
 */

import { gql } from '@apollo/client';

/**
 * Example: Create User Mutation
 * 
 * Usage:
 * const [createUser, { data, loading, error }] = useMutation(CREATE_USER);
 * 
 * createUser({
 *   variables: {
 *     input: {
 *       name: 'John Doe',
 *       email: 'john@example.com'
 *     }
 *   }
 * });
 */
export const CREATE_USER = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      id
      name
      email
      createdAt
    }
  }
`;

/**
 * Example: Update User Mutation
 */
export const UPDATE_USER = gql`
  mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      id
      name
      email
      updatedAt
    }
  }
`;

/**
 * Example: Delete User Mutation
 */
export const DELETE_USER = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id) {
      id
      success
    }
  }
`;

